import { defaultProfile } from '@/shared/constants'
import {
    getApiFavorites,
    markApiFavoriteItem,
    unMarkApiFavoriteItem,
} from './FavoritesService'
import { ProductTypeVOD } from '@/types/vod/vodContentTypes'

export type ProductTypeStreamIQ = 'channel' | ProductTypeVOD

export const getFavorites = async (profileId: string) => {
    if (profileId === defaultProfile.id) return
    return getApiFavorites(profileId)
}

export const markFavoriteItem = async (
    profileId: string,
    productType: string,
    productId: string
) => {
    {
        if (profileId === defaultProfile.id) return
        else return markApiFavoriteItem(profileId, productType, productId)
    }
}

export const unMarkFavoriteItem = async (
    profileId: string,
    productType: string,
    productId: string
) => {
    if (profileId === defaultProfile.id) return
    else return unMarkApiFavoriteItem(productId, profileId, productType)
}

export const FavoritesRepositoryStreamIQ = {
    getFavorites,
    markFavoriteItem,
    unMarkFavoriteItem,
}
